import React from "react";

import { useState } from "react";
import Login from "./Login";

import image from "../logos/keysAndSecrets.png";
import "./CommonDashboard.css";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";

import CircularProgress from "@material-ui/core/CircularProgress";
import ApikeyTable from "./ApikeyTable";
import MyApikeyForm from "./MyApikeyForm";
import { setApikey } from "../redux/slices/apikeySlice";
import { Box } from "@mui/material";

function APIKeysDashboard() {
  const [login, setLogin] = useState(false);
  const dispatch = useDispatch();
  const headers = useSelector((state) => state.header);

  const [apiloading, setApiLoading] = useState(true);

  function fetchData() {
    const api = localStorage.getItem("api");
    axios
      .get(api + `/list/apikeys`, headers)
      .then((response) => {
       
        dispatch(setApikey(response.data));

        setApiLoading(false);
      })
      .catch((error) => {
        console.error(error);
      });
  }
  React.useEffect(() => {
    fetchData();
  }, []);

  return login == null ? (
    <Login />
  ) : (
    <>
      {apiloading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <>
          <div className="mainContainer emms-main-container">
            <header className="no-margin">
              <figure>
                <img className="img" src={image} alt="Logo" />
              </figure>
            </header>

            <div className="tableAndButtonContainer">
              <Box

               sx={{
                textAlign: { xs: "left", md: "right" },
                paddingRight: { xs: "unset", md: "9%" },
                paddingLeft: { xs: "5%", md: "unset" }
              }}>
               
                <MyApikeyForm />
              </Box>
              <div  className="emms-container" style={{ marginLeft: "10%" }}>
                <ApikeyTable />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default APIKeysDashboard;
